/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UpdateProfileRequestIamUser,
    UpdateProfileRequestIamUserFromJSON,
    UpdateProfileRequestIamUserFromJSONTyped,
    UpdateProfileRequestIamUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateProfileRequest
 */
export interface UpdateProfileRequest {
    /**
     * 
     * @type {UpdateProfileRequestIamUser}
     * @memberof UpdateProfileRequest
     */
    iamUser?: UpdateProfileRequestIamUser;
}

export function UpdateProfileRequestFromJSON(json: any): UpdateProfileRequest {
    return UpdateProfileRequestFromJSONTyped(json, false);
}

export function UpdateProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUser': !exists(json, 'iam_user') ? undefined : UpdateProfileRequestIamUserFromJSON(json['iam_user']),
    };
}

export function UpdateProfileRequestToJSON(value?: UpdateProfileRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user': UpdateProfileRequestIamUserToJSON(value.iamUser),
    };
}


